import { compose, withProps } from 'recompose'

import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const normalizeLast4SSN = value => {
  // If the user modifies digits within sections, it will pass the validation,
  // because we don't want to re-render all the time, which cause cursor jumping.
  if (!value) return ''
  if (/^[0-9]{4}$/.test(value)) return value

  // Formatting
  const clean = (value.match(/[0-9]/g) || []).join('')
  return clean.substr(0, 4)
}

const enhance = compose(
  withProps({
    // using normalize instead o format because the form validation
    // is checking against what's in redux, but format only affects
    // what the user sees in the field, not what is getting saved.
    normalize: normalizeLast4SSN,
  }),
  toReduxFormField('InputSSN'),
)

export default enhance(InputText)
